import { CartLinesUpdateEvent } from '@shopify/events';

let pending = false;

function enableOffers() {
  document.querySelectorAll('[data-packie-add]').forEach((button) => {
    button.hidden = false;
    button.disabled = pending;
  });
}

enableOffers();
new MutationObserver(enableOffers).observe(document.body, { childList: true, subtree: true });

async function readCart(url) {
  const response = await fetch(`${url}.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart unavailable');
  return response.json();
}

async function readSections(ids) {
  const url = new URL(window.location.href);
  url.searchParams.set('sections', ids.join(','));
  const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
  if (!response.ok) throw new Error('Cart sections unavailable');
  return response.json();
}

function notifyCart(cart, sections, variantId, didAdd) {
  document.dispatchEvent(new CartLinesUpdateEvent({
    action: didAdd ? 'add' : 'change',
    context: 'cart',
    lines: didAdd ? [{ merchandiseId: variantId, quantity: 1 }] : [],
    promise: Promise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: cart.item_count, sections, source: 'bv-packie', didError: false },
    }),
  }));
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest?.('[data-packie-add]');
  if (!button) return;
  event.preventDefault();
  if (pending) return;
  const offer = button.closest('[data-packie-offer]');
  if (!offer) return;
  pending = true;
  enableOffers();
  button.textContent = offer.dataset.busyLabel;
  offer.setAttribute('aria-busy', 'true');
  const message = offer.querySelector('[data-packie-error]');
  message.hidden = true;
  const ids = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId).filter(Boolean))].slice(0, 5);
  const checkoutButtons = [...document.querySelectorAll('button[name="checkout"]')].filter((item) => !item.disabled);
  checkoutButtons.forEach((item) => { item.disabled = true; });
  const productId = offer.dataset.productId;
  const variantId = offer.dataset.variantId;
  const containsBooster = (cart) => cart.items.some((item) => String(item.product_id) === productId);
  let attempted = false;
  let succeeded = false;
  try {
    let cart = await readCart(offer.dataset.cartUrl);
    let sections;
    if (!containsBooster(cart)) {
      if (!cart.item_count) throw new Error('Empty cart');
      attempted = true;
      const response = await fetch(`${offer.dataset.addUrl}.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ids.join(','), sections_url: window.location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error('Booster unavailable');
      sections = result.sections;
      cart = await readCart(offer.dataset.cartUrl);
    }
    sections ||= await readSections(ids);
    notifyCart(cart, sections, variantId, attempted);
    succeeded = true;
  } catch {
    if (attempted) {
      try {
        const cart = await readCart(offer.dataset.cartUrl);
        if (containsBooster(cart)) {
          notifyCart(cart, await readSections(ids), variantId, true);
          succeeded = true;
        }
      } catch {}
    }
    if (!succeeded) {
      message.textContent = offer.dataset.error;
      message.hidden = false;
    }
  } finally {
    if (succeeded) {
      document.querySelectorAll('[data-packie-offer]').forEach((item) => { item.hidden = true; });
      const container = offer.closest('cart-items-component');
      requestAnimationFrame(() => requestAnimationFrame(() => container?.querySelector('button[name="checkout"]')?.focus({ preventScroll: true })));
    }
    pending = false;
    checkoutButtons.forEach((item) => { if (item.isConnected) item.disabled = false; });
    offer.removeAttribute('aria-busy');
    button.textContent = offer.dataset.addLabel;
    enableOffers();
  }
}, true);
